import { LogoMark } from "@/components/Logo";

export const DtMark = () => (
  <span className="shrink-0" data-testid="dt-header-logo">
    <span className="studio-hide"><LogoMark className="h-6 sm:h-7" /></span>
    <span className="studio-only"><LogoMark variant="studio-dark" className="h-6 sm:h-7" /></span>
  </span>
);
